<template>
  <div class="app">
    <div class="Edit-base">
      <div class="title">编辑个人信息</div>
      <div class="Edit-content">
        <div class="content-box">
          <div class="box-left">
            <div class="left-item">
              <div class="item-title import">姓名</div>
              <div class="item-content">
                <el-input placeholder="请输入姓名" v-model="post.name" size="small" clearable>
                </el-input>
              </div>
            </div>
            <div class="left-item">
              <div class="item-title import">出生年份</div>
              <div class="item-content">
                <el-date-picker v-model="post.birth_Year" type="year" size="small" placeholder="选择出生年份">
                </el-date-picker>
              </div>
            </div>
            <div class="left-item">
              <div class="item-title import">求职状态</div>
              <div class="item-content">
                <el-select size="small" v-model="post.job_Status" placeholder="请选择求职状态">
                  <el-option v-for="item in wantJobStutas" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="left-item">
              <div class="item-title">微信</div>
              <div class="item-content">
                <el-input size="small" placeholder="请输入微信" maxlength="11" v-model="wechat" clearable>
                </el-input>
              </div>
            </div>
          </div>
          <div class="box-between">
            <div class="between-item">
              <div class="item-title import">性别</div>
              <div class="item-content">
                <el-select size="small" v-model="post.gender" placeholder="请选择性别">
                  <el-option v-for="item in genders" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="between-item">
              <div class="item-title import">工作年限</div>
              <div class="item-content">
                <el-select size="small" v-model="post.work_Years" placeholder="请选择工作年限">
                  <el-option v-for="item in workYears" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="between-item">
              <div class="item-title import">手机</div>
              <div class="item-content">
                <el-input size="small" placeholder="请输入手机" maxlength="11" v-model="post.phone" clearable>
                </el-input>
              </div>
            </div>
            <div class="between-item">
              <div class="item-title">人才标签</div>
              <div class="item-content">
                <el-select size="small" v-model="label" placeholder="请选择人才标签">
                  <el-option v-for="item in labels" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="box-right">
            <div class="right-item">
              <div class="item-title import">最高学历</div>
              <div class="item-content">
                <el-select size="small" v-model="post.highest_Degree" placeholder="请选择最高学历">
                  <el-option v-for="item in highestEdus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="right-item">
              <div class="item-title import">目前薪资</div>
              <div class="item-content salary">
                <el-input size="small" placeholder="请输入目前薪资" maxlength="4" v-model="post.current_Salary">
                </el-input>
              </div>
            </div>
            <div class="right-item">
              <div class="item-title">邮箱</div>
              <div class="item-content">
                <el-input size="small" placeholder="请输入邮箱" v-model="email" clearable>
                </el-input>
              </div>
            </div>
            <div class="right-item">
              <div class="item-content btn">
                <el-button size="small" @click="cancel">取消</el-button>
                <el-button size="small" type="primary" @click="save">保存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateBaseInfo } from '@/request/api'
export default {
  props: {
    val: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      wantJobStutas: [
        {
          value: 1,
          label: '离职-随时到岗'
        },
        {
          value: 2,
          label: '在职-暂不考虑'
        },
        {
          value: 3,
          label: '在职-考虑机会'
        },
        {
          value: 4,
          label: '在职-月内到岗'
        }
      ],
      genders: [
        {
          value: 0,
          label: '女'
        },
        {
          value: 1,
          label: '男'
        }
      ],
      workYears: [
        {
          value: 0,
          label: '1年以内'
        },
        {
          value: 1,
          label: '1年'
        },
        {
          value: 2,
          label: '2年'
        },
        {
          value: 3,
          label: '3年'
        },
        {
          value: 4,
          label: '4年'
        },
        {
          value: 5,
          label: '5年'
        },
        {
          value: 6,
          label: '6年'
        },
        {
          value: 7,
          label: '7年'
        },
        {
          value: 8,
          label: '8年'
        },
        {
          value: 9,
          label: '9年'
        },
        {
          value: 10,
          label: '10年'
        },
        {
          value: 11,
          label: '11年'
        },
        {
          value: 12,
          label: '12年'
        },
        {
          value: 13,
          label: '13年'
        },
        {
          value: 14,
          label: '14年'
        },
        {
          value: 15,
          label: '14年以上'
        }
      ],
      highestEdus: [
        {
          value: 1,
          label: '大专以下'
        },
        {
          value: 2,
          label: '大专'
        },
        {
          value: 3,
          label: '本科'
        },
        {
          value: 4,
          label: '硕士'
        },
        {
          value: 5,
          label: '博士'
        },
        {
          value: 6,
          label: 'MBA/EMBA'
        }
      ],
      label: '',
      labels: [{
        value: 1,
        label: '战略匹配型(超出预期)'
      }, {
        value: 2,
        label: '胜任匹配型(符合要求)'
      }, {
        value: 3,
        label: '发展适配型(具备潜力)'
      }, {
        value: 4,
        label: '暂不匹配型(不太符合)'
      }],
      wechat: '',
      email: '',
      post: {
        ID: '',
        comID: '',
        job_Status: '', // 求职状态
        birth_Year: '', // 出生年份
        name: '', // 姓名
        phone: '', // 手机
        gender: '', // 性别
        work_Years: '', // 工作年限
        highest_Degree: '', // 最高学历
        current_Salary: '', // 目前薪资
        username: '',
      }
    }
  },
  created() {
    this.post.ID = this.val.id
    this.post.comID = this.val.comID
    this.post.job_Status = this.val.jobStatus
    this.post.birth_Year = this.val.birthDate
    this.post.phone = this.val.phone
    this.wechat = this.val.wechat
    this.post.gender = this.val.gender
    this.label = this.val.label
    this.post.username = JSON.parse(sessionStorage.getItem('LoginInfo')).username
    let currentYear = new Date().getFullYear()
    this.val.workYear = currentYear - this.val.workYear
    if (this.val.workYear > 15) {
      this.post.work_Years = 15
    } else {
      this.post.work_Years = this.val.workYear
    }
    this.email = this.val.email
    this.post.highest_Degree = this.val.highEdu
    this.post.current_Salary = this.val.currenSalary
    this.post.name = this.val.name
  },
  methods: {
    mqAddress(value) {
      this.post.nowAdress = value
    },
    hjAddress(value) {
      this.post.oldAdress = value
    },
    cancel() {
      this.$emit('baseInfoShow', false)
    },
    textBetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key)
      if (g_left != -1) {
        g_left = g_left + left_key.length
        var g_right = str.indexOf(right_key, g_left)
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left)
      }
    },
    isPostDataEmpty(post) {
      // 检查 post 对象中的每个属性是否为空
      for (let key in post) {
        if (post.hasOwnProperty(key) && post[key] === '') {
          // 如果发现空属性，返回 true
          return true
        }
      }
      // 如果所有属性都不为空，返回 false
      return false
    },
    async save() {
      if (this.isPostDataEmpty(this.post)) {
        this.$message({
          message: '请完善数据后再提交！',
          type: 'warning'
        })
        return
      }
      this.post.email = this.email;
      this.post.wechat = this.wechat;
      this.post.label = this.label;

      this.post.ID = this.$route.query.resumeID;
      const date = new Date(this.post.birth_Year);
      this.post.birth_Year = date.getFullYear();
      const { data: res } = await updateBaseInfo(this.post);
      if (res.code === 200) {
        this.$emit('baseInfoShow', true);
      } else {
        this.$message.warning(res.message);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  background: #fff;
  padding: 20px;

  .Edit-base {
    background: #f4f5fb;
    padding: 20px;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      color: #333;
      margin-bottom: 20px;
    }

    .Edit-content {
      width: 100%;

      .content-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;

        .item-title {
          font-size: 14px;
          color: #333;
          line-height: 40px;
        }

        .import::before {
          content: '*';
          color: #f56c6c;
          margin-right: 4px;
        }

        .item-content {
          width: 220px;
          margin-bottom: 10px;

          ::v-deep .el-select {
            width: 100%;
          }
        }

        .salary {
          ::v-deep .el-input {
            position: relative;
          }

          ::v-deep .el-input::before {
            content: 'K';
            position: absolute;
            color: #333;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        .btn {
          display: flex;
          padding-top: 40px;

          .el-button {
            width: 50%;
          }
        }
      }
    }
  }
}
</style>